import React from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute as Route } from '../PrivateRoute/PrivateRoute';
import Contents from '../../pages/Contents';
import Courses from '../../pages/Courses';
import CreateAndEditContent from '../../pages/CreateAndEditContent';
import CreateAndEditCourse from '../../pages/CreateAndEditCourse';
import Profile from '../../pages/Profile';
import Engagement from '../../pages/Engagement';
import FinishedCourses from '../../pages/Accesses';
import Lessons from '../../pages/Lessons';
import AboutUs from '../../pages/AboutUs';
import Exams from '../../pages/Exams';
import Questions from '../../pages/Questions';
import CreateAndEditQuestion from '../../pages/CreateAndEditQuestion';
import CreateAndEditExam from '../../pages/CreateAndEditExam';
import Categories from '../../pages/Categories';
import ForumCategories from '../../pages/Forum/Categories';
import CreateAndEditCategory from '../../pages/CreateAndEditCategory';
import CreateAndEditForumCategory from '../../pages/Forum/Categories/components/CreateAndEditCategory';
import Authors from '../../pages/Authors';
import CreateAndEditAuthors from '../../pages/CreateAndEditAuthors';
import ContentTrail from '../../pages/ContentTrails';
import CreateAndEditContentTrails from '../../pages/CreateAndEditContentTrails';
import Series from '../../pages/Series';
import CreateAndEditSerie from '../../pages/CreateAndEditSerie';
import ForumTag from '../../pages/Forum/Tags';
import CreateAndEditForumTag from '../../pages/Forum/Tags/components/CreateAndEditTags';
import CreateAndEditFAQ from '../../pages/CreateAndEditFAQ';
import FAQ from '../../pages/FAQ';
import Segmentation from '../../pages/Segmentation';
import CreateAndEditSegmentation from '../../pages/CreateAndEditSegmentation';
import Lives from '../../pages/Lives';
import CreateAndEditLive from '../../pages/CreateAndEditLive';
import Users from '../../pages/Users';
import EditQuestions from '../../pages/EditQuestions';
import Depositions from '../../pages/Depositions';
import ExamsReport from '../../pages/ExamsReport';
import EditComments from '../../pages/EditComments';
import EngagementTrail from '../../pages/EngagementTrail';
import EngagementTestimonial from '../../pages/EngagementTestimonial';
import CreateAndEditFileContents from '../../pages/CreateAndEditFileContents';
import FileContents from '../../pages/FileContents';
import TestsReceived from '../../pages/TestsReceived';

const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <Route exact path="/profile" component={Profile} />

        <Route exact path="/users" component={Users} />

        <Route exact path="/authors" component={Authors} />
        <Route exact path="/create-author" component={CreateAndEditAuthors} />
        <Route
          exact
          path="/edit-author/:authorId"
          component={CreateAndEditAuthors}
        />

        {/* <Route exact path="/lives" component={Lives} />
        <Route exact path="/create-live" component={CreateAndEditLive} />
        <Route exact path="/edit-live/:liveId" component={CreateAndEditLive} /> */}

        <Route exact path="/depositions" component={Depositions} />
        <Route exact path="/categories" component={Categories} />
        <Route
          exact
          path="/create-category"
          component={CreateAndEditCategory}
        />
        <Route
          exact
          path="/edit-category/:categoryId"
          component={CreateAndEditCategory}
        />

        <Route exact path="/contents" component={Contents} />
        <Route exact path="/create-content" component={CreateAndEditContent} />
        <Route
          exact
          path="/edit-content/:contentId"
          component={CreateAndEditContent}
        />

        <Route exact path="/trails/contents" component={ContentTrail} />
        <Route
          exact
          path="/trails/create-content"
          component={CreateAndEditContentTrails}
        />
        <Route
          exact
          path="/trails/edit-content/:contentId"
          component={CreateAndEditContentTrails}
        />

        <Route exact path="/trails/file" component={FileContents} />
        <Route
          exact
          path="/trails/create-file"
          component={CreateAndEditFileContents}
        />
        <Route
          exact
          path="/trails/edit-file/:fileContentId"
          component={CreateAndEditFileContents}
        />

        <Route exact path="/trails/episodes" component={Courses} />
        <Route
          exact
          path="/trails/create-course"
          component={CreateAndEditCourse}
        />
        <Route
          exact
          path="/trails/edit-course/:courseId"
          component={CreateAndEditCourse}
        />

        <Route exact path="/trails/series" component={Series} />
        <Route
          exact
          path="/trails/create-serie"
          component={CreateAndEditSerie}
        />
        <Route
          exact
          path="/trails/edit-serie/:serieId"
          component={CreateAndEditSerie}
        />

        <Route exact path="/faqs" component={FAQ} />
        <Route exact path="/create-faq" component={CreateAndEditFAQ} />
        <Route exact path="/edit-faq/:faqId" component={CreateAndEditFAQ} />

        <Route exact path="/forum/categories" component={ForumCategories} />
        <Route
          exact
          path="/forum/categories/:categoryId/questions"
          component={EditQuestions}
        />
        <Route
          exact
          path="/forum/categories/:categoryId/questions/:questionId/comments"
          component={EditComments}
        />

        <Route
          exact
          path="/forum/create-category"
          component={CreateAndEditForumCategory}
        />
        <Route
          exact
          path="/forum/edit-category/:categoryId"
          component={CreateAndEditForumCategory}
        />

        <Route exact path="/forum/tags" component={ForumTag} />
        <Route
          exact
          path="/forum/create-tag"
          component={CreateAndEditForumTag}
        />
        <Route
          exact
          path="/forum/edit-tag/:tagId"
          component={CreateAndEditForumTag}
        />

        <Route exact path="/lessons" component={Lessons} />

        <Route exact path="/segmentation" component={Segmentation} />
        <Route
          exact
          path="/edit-segmentation/:segmentationId"
          component={CreateAndEditSegmentation}
        />

        <Route exact path="/reports/engagement" component={Engagement} />
        <Route
          exact
          path="/reports/finished-courses"
          component={FinishedCourses}
        />
        <Route exact path="/reports/exams" component={ExamsReport} />

        <Route exact path="/about/about_us" component={AboutUs} />

        <Route exact path="/exams-questions/exams" component={Exams} />
        <Route
          exact
          path="/exams-questions/create-exam"
          component={CreateAndEditExam}
        />
        <Route
          exact
          path="/exams-questions/edit-exam/:examId"
          component={CreateAndEditExam}
        />

        <Route exact path="/exams-questions/questions" component={Questions} />
        <Route
          exact
          path="/exams-questions/create-question"
          component={CreateAndEditQuestion}
        />
        <Route
          exact
          path="/exams-questions/edit-question/:questionId"
          component={CreateAndEditQuestion}
        />

        <Route exact path="/reports/engagement" component={Engagement} />
        <Route
          exact
          path="/reports/engagementTrail"
          component={EngagementTrail}
        />
        <Route
          exact
          path="/reports/engagementTestimonial"
          component={EngagementTestimonial}
        />
        <Route exact path="/reports/accesses" component={FinishedCourses} />
        <Route exact path="/tests-received" component={TestsReceived} />
      </Switch>
    </>
  );
};

export default Routes;
